import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/app/ui/assets/svg/clock.svg'


const _hoisted_1 = { class: "flex flex-col pt-2 pb-6 pr-5" }
const _hoisted_2 = { class: "grid grid-cols-3 mt-6 gap-y-8" }
const _hoisted_3 = { class: "flex flex-col w-full gap-y-8 pt-8" }
const _hoisted_4 = { class: "flex flex-row w-full" }
const _hoisted_5 = { class: "flex flex-row" }
const _hoisted_6 = { class: "flex flex-row" }
const _hoisted_7 = {
  class: "px-3 py-4 flex flex-row items-center rounded-lg max-w-max",
  style: {"background-color":"#f5f5f5","box-shadow":"0px 1px 4px 0px rgba(26, 20, 33, 0.15)"}
}
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-6 max-w-none mr-2",
  alt: "clock"
}, null, -1)
const _hoisted_9 = { class: "text-14px font-normal font-montserrat text-gray-lp-300" }
const _hoisted_10 = { class: "space-y-2 pt-2" }
const _hoisted_11 = { class: "text-12px font-normal text-gray-lp-500 max-w-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_CardAddress = _resolveComponent("CardAddress")!
  const _component_ChipsV2 = _resolveComponent("ChipsV2")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    scrollSidebar: "",
    customClass: "px-0",
    onBack: _ctx.goBack,
    title: _ctx.detailData.pickupScheduleName,
    loading: _ctx.apiDetailData.loading,
    error: !!_ctx.apiDetailData.errorType,
    errorType: _ctx.apiDetailData.errorType,
    onTryAgain: _ctx.fetchDetail
  }, {
    data: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Title, {
          label: _ctx.$t('pickupCorporate.detailInfo')
        }, null, 8, ["label"]),
        _createVNode("div", null, [
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('pickupCorporate.configName'),
              value: _ctx.detailData.pickupScheduleName
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('pickupCorporate.clientRef'),
              value: _ctx.detailData.pickupScheduleClientName
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('pickupCorporate.the3lcPickUp'),
              value: _ctx.detailData.pickupScheduleCityId
            }, null, 8, ["label", "value"])
          ]),
          (!_ctx.isPcaEmpty)
            ? (_openBlock(), _createBlock(_component_CardAddress, {
                key: 0,
                data: _ctx.detailData
              }, null, 8, ["data"]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_3, [
            (_ctx.isPcaEmpty)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 0,
                  label: _ctx.$t('pickupCorporate.districtCity'),
                  value: _ctx.detailData.pickupScheduleDistrictName
                }, null, 8, ["label", "value"]))
              : _createCommentVNode("", true),
            (_ctx.isPcaEmpty)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 1,
                  label: _ctx.$t('pickupCorporate.addressPickUp'),
                  value: _ctx.detailData.pickupScheduleAddress
                }, null, 8, ["label", "value"]))
              : _createCommentVNode("", true),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('pickupCorporate.courierNote'),
              value: _ctx.detailData.pickupScheduleCourierNote
            }, null, 8, ["label", "value"]),
            (_ctx.isPcaEmpty)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 2,
                  label: _ctx.$t('pickupCorporate.coordLabelGoogle'),
                  value: _ctx.detailData.pickupScheduleGeoloc
                }, null, 8, ["label", "value"]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_DataWrapper, {
                class: "w-1/2",
                label: _ctx.$t('pickupCorporate.vehicleType'),
                value: _ctx.detailData.pickupScheduleTransportType
              }, null, 8, ["label", "value"]),
              _createVNode(_component_DataWrapper, {
                class: "w-1/2",
                label: _ctx.$t('pickupCorporate.serviceType'),
                value: 
                  _ctx.detailData.pickupScheduleServiceCodes.split(',').join(', ')
                
              }, null, 8, ["label", "value"])
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_DataWrapper, {
                class: "w-1/2",
                label: _ctx.$t('pickupCorporate.estimateTonase'),
                value: _ctx.detailData.pickupScheduleEstTotalTonase + 'kg'
              }, null, 8, ["label", "value"]),
              _createVNode(_component_DataWrapper, {
                class: "w-1/2",
                label: _ctx.$t('pickupCorporate.estimateKoli'),
                value: _ctx.detailData.pickupScheduleEstTotalKoli
              }, null, 8, ["label", "value"])
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_DataWrapper, {
                class: "w-1/2",
                label: _ctx.$t('pickupCorporate.dateStartPickUp'),
                value: _ctx.detailData.formatStartAt
              }, null, 8, ["label", "value"]),
              _createVNode(_component_DataWrapper, {
                class: "w-1/2",
                label: _ctx.$t('pickupCorporate.dateEndPickUp'),
                value: _ctx.detailData.formatEndAt
              }, null, 8, ["label", "value"])
            ]),
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: _ctx.$t('pickupCorporate.timePickUp'),
              value: _ctx.detailData.pickupScheduleTime
            }, null, 8, ["label", "value"]),
            _createVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode("p", _hoisted_9, [
                _createTextVNode(_toDisplayString(_ctx.$t("pickupCorporate.repeatPickUpLabel")) + " : ", 1),
                _createVNode("strong", null, _toDisplayString(_ctx.formattedDetailRepeatDays) + " - " + _toDisplayString(_ctx.$t("pickupCorporate.nextPickUpDay")) + " " + _toDisplayString(_ctx.detailData.formatNextRun), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    "sub-data": _withCtx(() => [
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('pickupCorporate.statusSchedule')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ChipsV2, {
            label: _ctx.detailData.pickupScheduleStatus,
            class: "mt-1"
          }, null, 8, ["label"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('pickupCorporate.dateCreated'),
        value: _ctx.detailData.formatCreatedAt,
        caption: _ctx.detailData.pickupScheduleCreatedBy
      }, null, 8, ["label", "value", "caption"]),
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('pickupCorporate.dateUpdated'),
        value: _ctx.detailData.formatUpdatedAt,
        caption: _ctx.detailData.pickupScheduleUpdatedBy
      }, null, 8, ["label", "value", "caption"]),
      _withDirectives(_createVNode(_component_LpButton, {
        title: _ctx.$t('pickupCorporate.editButton'),
        customClass: "w-1/2",
        onClick: _ctx.goToEdit,
        outline: "",
        textColor: "red-lp-100"
      }, null, 8, ["title", "onClick"]), [
        [_vShow, _ctx.isEditAble]
      ]),
      (_ctx.isEditAble)
        ? (_openBlock(), _createBlock(_component_DataWrapper, {
            key: 0,
            label: _ctx.$t('pickupCorporate.statusConfig'),
            class: "my-6 col-span-2"
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_10, [
                _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("pickupCorporate.clickToActivateStatus")), 1),
                _createVNode(_component_Toggle, {
                  "onUpdate:modelValue": [
                    _ctx.onUpdateStatusActive,
                    _cache[1] || (_cache[1] = ($event: any) => (_ctx.statusActive = $event))
                  ],
                  modelValue: _ctx.statusActive,
                  textActive: _ctx.$t('pickupCorporate.statusActive'),
                  textInactive: _ctx.$t('pickupCorporate.statusInactive')
                }, null, 8, ["onUpdate:modelValue", "modelValue", "textActive", "textInactive"])
              ])
            ]),
            _: 1
          }, 8, ["label"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onBack", "title", "loading", "error", "errorType", "onTryAgain"]))
}